import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState, useRef } from "react";
import LanguageContext from "../context/LanguageContext";
import { getInforUser, updateInforUser, uploadFile, } from "../services/api/account.service";
import {
    union, changeIcon, uploadIcon, takePicture, closeIcon, rorateFrame, zoom, rorateFrameActive, zoomActive, minus, plus, unView, view
} from "../assets/images/images";
import { validateEmail, validatePassword } from "../share/validation";
import { changePassword, resetPaswordConfirm } from "../services/api/auth.service";
import Webcam from 'react-webcam';
import AvatarEditor from 'react-avatar-editor';
import DatePicker from "react-datepicker";
import { publish } from "../services/loadingServices/loading.service";
import { showApiError } from "../services/apiError";

const AccountInfor = () => {
    const location = useLocation();
    const nav = useNavigate();
    const { language } = useContext(LanguageContext);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const editorRef = useRef<AvatarEditor>(null);
    const webcamRef = useRef<Webcam>(null);
    const dropdownGenderRef = useRef<HTMLDivElement>(null);
    const userId: string = localStorage.getItem("userId") || "";
    const companyId: string = localStorage.getItem("companyId") || "";
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupPassword, setShowPopupPassword] = useState<any>(false);
    const [searchGender, setSearchGender] = useState("");
    const [isGenderTypeDropdownOpen, setIsGenderTypeDropdownOpen] = useState(false);
    const [gender, setGender] = useState<any[]>([
        {
            id: "4",
            code: "Male",
            name: "Male"
        },
        {
            id: "5",
            code: "Female",
            name: "Female"
        },
    ]);
    const [typeChoose, setTypeChoose] = useState<any>("zoom");
    const [showPopupChooseImage, setShowPopupChooseImage] = useState(false);
    const [formValues, setFormValues] = useState<any>({});
    const [formValuesPassword, setFormValuesPassword] = useState<any>({});
    const [image, setImage] = useState<File | string | null>(null);
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);
    const [startDate, setStartDate] = useState(new Date());
    const [useCamera, setUseCamera] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState("Your passsword has been reset successfully.");
    const [showFailedPopup, setShowFailedPopup] = useState(false);
    const [errors, setErrors] = useState({
        email: "",
        newPassword: "",
        confirmPassword: "",
        currentPassword: "",

    })
    const [showPassword, setShowPassword] = useState<{ newPassword: boolean; confirmPassword: boolean; currentPassword: boolean; }>({
        newPassword: false,
        confirmPassword: false,
        currentPassword: false,
    });
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            setImage(e.target.files[0]);
            setShowPopup(false);
            setShowPopupChooseImage(true);
        }
    };
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownGenderRef.current && !dropdownGenderRef.current.contains(event.target as Node)) {
                setIsGenderTypeDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.addEventListener('mousedown', handleClickOutside);
    }, []);
    const handleCapture = () => {
        if (webcamRef.current) {
            setShowPopup(false);
            setShowPopupChooseImage(true);
            const screenshot = webcamRef.current.getScreenshot();
            if (screenshot) {
                setImage(screenshot);
                setUseCamera(false);
            }
        }
    };
    const formatDate = (dateString: any) => {
        const date = new Date(dateString);
        const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };
    const handleSave = () => {
        if (editorRef.current) {
            const canvas = editorRef.current.getImageScaledToCanvas();
            canvas.toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], 'edited-image.png', { type: 'image/png' });
                    setImage(file);
                }
            }, 'image/png');
            setShowPopupChooseImage(false);
            setRotate(0);
            setScale(1);
        }
    };
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValues((prev: any) => ({ ...prev, [name]: value }));
    }
    const handleChangePassword = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormValuesPassword((prev: any) => ({ ...prev, [name]: value }));
        setErrors((prev: any) => {
            let updatedErrors = { ...prev };
            if (name === 'newPassword') {
                const passwordError = validatePassword(value);
                updatedErrors.newPassword = passwordError;
            }

            if (name === 'confirmPassword' || name === 'newPassword') {
                const newPasswordValue = name === 'newPassword' ? value : formValuesPassword.newPassword;
                const confirmPasswordValue = name === 'confirmPassword' ? value : formValuesPassword.confirmPassword;
                updatedErrors.confirmPassword = (confirmPasswordValue && newPasswordValue !== confirmPasswordValue)
                    ? 'Passwords do not match'
                    : '';
            }

            if (name === 'currentPassword') {
                updatedErrors.currentPassword = value ? '' : 'Current password is required';
            }

            return updatedErrors;
        });
    }

    const isFormStepTwo = () => {
        const { currentPassword, newPassword, confirmPassword } = formValuesPassword;

        if (!currentPassword || !newPassword || !confirmPassword) {
            return false;
        }

        if (validatePassword(newPassword) !== '') {
            return false;
        }

        if (errors.newPassword || errors.confirmPassword) {
            return false;
        }

        if (newPassword !== confirmPassword) {
            return false;
        }

        return true;
    };

    useEffect(() => {
        const pathLocalStorage = localStorage.getItem("language");
        const pathRedirect = location.pathname.split("/")[1];
        if (pathRedirect !== pathLocalStorage && pathRedirect.length > 0) {
        } else {
            getAccountInfor();
        }

    }, []);
    const getAccountInfor = async () => {
        try {
            const response: any = await getInforUser(userId);
            setStartDate(new Date(response.data.dob));
            setSearchGender(response.data.gender)
            setFormValues(response.data);
        } catch (error) {
            console.error("Error loading terms:", error);
        } finally {
        }
    };

    const handleDivClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleSubmitStepTwo = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        try {
            const payload: any = {
                newPassword: formValuesPassword.newPassword, currentPassword: formValuesPassword.currentPassword, userId
            }
            const response = await changePassword(payload);
            setShowSuccessPopup(true);
            setShowPopupPassword(false);
            setFormValuesPassword({ ...formValuesPassword, newPassword: "", confirmPassword: "", currentPassword: "" });
            setErrors({ ...errors, newPassword: "", confirmPassword: "", currentPassword: "" });
        } catch (error: any) {
            showApiError(error, { language, setFieldErrors: (fe) => setErrors((prev: any) => ({ ...prev, ...fe })) });
        }
    }
    const handleSubmitChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        publish('loading', true);
        try {
            let responseFile: any;
            if (image) {
                const formData = new FormData();
                image && formData.append("file_upload", image);
                responseFile = await uploadFile(formData);
            }
            const payload = {
                userId, fullName: formValues?.fullName, emailAddress: formValues?.emailAddress, gender: formValues?.gender, dob: formValues?.dob ? formValues?.dob : startDate, image: responseFile?.data?.data
            }
            const response = await updateInforUser(payload);
            setMessageSuccess("Your profile has been updated successfully.");
            setShowSuccessPopup(true);
        } catch (error: any) {
            showApiError(error, { language });
        } finally {
            publish('loading', false);
            getAccountInfor();
            setImage(null);
            publish('reloadHeader', {});
        }
    }

    const handleChooseTakePicture = () => {
        navigator.mediaDevices.getUserMedia({ video: true })
            .then((stream) => {
                setUseCamera(true); setShowPopup(false); setShowPopupChooseImage(true)
                stream.getTracks().forEach(track => track.stop());
            })
            .catch((err) => {
                setShowFailedPopup(true);
                console.error('Camera permission denied', err);
            });
    }
    const handleGenderSelect = (gender: string, termName: string) => {
        setFormValues((prev: any) => ({ ...prev, gender: gender }));
        setSearchGender(termName);
        setIsGenderTypeDropdownOpen(false);
    };
    const handleStartDate = (value: any) => {
        setStartDate(value);
        setFormValues({ ...formValues, dob: value });
    };
    return (
        <div className="container space-y-10">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-x-4">
                    {
                        (image || formValues?.image) ?
                            <div className="w-16 h-16  cursor-pointer rounded-full overflow-hidden" onClick={() => { setShowPopup(true) }}>
                                <img
                                    src={typeof image === 'string' ? image : (image ? URL.createObjectURL(image) : formValues?.image)}
                                    className="w-full h-full"
                                />
                            </div>
                            :
                            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#7EB7B9] text-[20px] font-tafel font-semibold leading-[32px] text-white uppercase cursor-pointer" onClick={() => { setShowPopup(true) }}>
                                {formValues?.firstName?.slice(0, 1)}{formValues?.lastName?.slice(0, 1)}
                            </div>
                    }
                    <div className="">
                        <p className="text-[24px] font-tafel text-main font-semibold">{formValues?.firstName} {formValues?.lastName}</p>
                    </div>
                </div>
                <div className="p-[10px] flex items-center gap-x-[10px] bg-[#FFFFFF] rounded-md shadow-button cursor-pointer" onClick={() => { setShowPopupPassword(true) }}>
                    <div className="w-[46px] h-[46px] flex items-center justify-center bg-[#E7F1F1]">
                        <img src={union} className="" />
                    </div>
                    <div className="">
                        <p className="text-[12px] font-tafel leading-[18px] text-[#1E1E36] font-semibold cursor-pointer">{language?.["Change password"] ?? "Change password"}</p>
                        <p className="text-[12px] font-tafel leading-[18px] text-[#767685] lg:hidden">{language?.["Last changed:"] ?? "Last changed:"} <span className="text-[#1E1E36]">{formatDate(formValues?.passwordDate)}</span></p>
                    </div>
                </div>
            </div>
            <div className="py-6 px-4 rounded-lg bg-white shadow-button space-y-8">
                <div className="space-y-1">
                    <p className="text-[16px] text-main font-semibold leading-[24px]">{language?.["Basic Info"] ?? "Basic Info"}</p>
                </div>
                <div className="space-y-4">
                    <div className="h-12 flex items-center gap-x-6">
                        <div className="w-[224px] h-full">
                            <p className="text-[14px] text-subtitle leading-[22px] ">{language?.["Full Name"] ?? "Full Name"}</p>
                        </div>
                        <div className="h-full border-b-[1px] border-b-[#E7F1F1] w-[calc(100%-224px)] relative">
                            <input
                                name="fullName"
                                value={formValues.fullName}
                                onChange={handleChange}
                                className={`text-[14px] text-main leading-[22px] border outline-none focus-none bg-transparent w-full border-none `}
                            />
                            <div className="absolute top-0 w-8 h-8 right-0 cursor-pointer">
                                <img src={changeIcon} className="" />
                            </div>
                        </div>
                    </div>
                    <div className="h-12 flex items-center gap-x-6">
                        <div className="w-[224px] h-full">
                            <p className="text-[14px] text-subtitle leading-[22px] ">{language?.["Email"] ?? "Email"}</p>
                        </div>
                        <div className="h-full border-b-[1px] border-b-[#E7F1F1] w-[calc(100%-224px)] relative">
                            <input
                                name="emailAddress"
                                value={formValues.emailAddress}
                                onChange={handleChange}
                                className={`text-[14px] text-main leading-[22px] border outline-none focus-none bg-transparent w-full border-none `}
                            />
                            <div className="absolute top-0 w-8 h-8 right-0 cursor-pointer">
                                <img src={changeIcon} className="" />
                            </div>
                        </div>
                    </div>
                    <div className="h-12 flex items-center gap-x-6">
                        <div className="w-[224px] h-full">
                            <p className="text-[14px] text-subtitle leading-[22px] ">{language?.["Gender"] ?? "Gender"}</p>
                        </div>
                        <div className="h-full border-b-[1px] border-b-[#E7F1F1] w-[calc(100%-224px)]" >
                            <div className="relative" ref={dropdownGenderRef}>
                                <input
                                    tabIndex={3}
                                    type="text"
                                    value={searchGender}
                                    onChange={(e) => {
                                        setSearchGender(e.target.value);
                                        setIsGenderTypeDropdownOpen(true);
                                    }}
                                    onClick={() => setIsGenderTypeDropdownOpen(true)}
                                    className={`text-[14px] text-main leading-[22px] border outline-none focus-none bg-transparent w-full border-none `}
                                />
                                {isGenderTypeDropdownOpen && (
                                    <div className="absolute z-10 w-full mt-1 bg-white border border-[#EBEBED] rounded-lg max-h-60 overflow-auto p-1 shadow-extend max-w-[300px]">
                                        {gender
                                            .map(gender => (
                                                <div
                                                    key={gender.id}
                                                    style={{ padding: "8px 6px", borderRadius: "4px" }}
                                                    className="cursor-pointer hover:bg-[#E7F1F1] text-main text-[14px] font-tafel duration-300"
                                                    onClick={() => handleGenderSelect(gender.code, gender.name)}
                                                >
                                                    {gender.name}
                                                </div>
                                            ))
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-6">
                        <div className="w-[224px] h-full">
                            <p className="text-[14px] text-subtitle leading-[22px] ">{language?.["Birthday"] ?? "Birthday"}</p>
                        </div>
                        <div className="h-full w-[300px]">
                            <DatePicker
                                tabIndex={6}
                                dateFormat="dd-MM-yyyy"
                                placeholderText={`Select a date of birth`}
                                name="startTime"
                                className="text-[14px] text-main leading-[22px] border outline-none focus-none bg-transparent w-full border-none"
                                selected={startDate}
                                onChange={(e) => handleStartDate(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-end gap-x-3">
                <div className="py-[10px] rounded-md px-4 cursor-pointer border border-[#E2E8F0]" onClick={() => { nav("/") }}>
                    <p className="text-[14px] text-[#334155] leading-[20px] font-tafel ">{language?.["Cancel"] ?? "Cancel"}</p>
                </div>
                <div className="py-[10px] rounded-md px-4 cursor-pointer bg-[#3AC0C4]" onClick={(e: any) => { handleSubmitChange(e) }}>
                    <p className="text-[14px] text-main leading-[20px] font-tafel font-semibold ">{language?.["Save Changes"] ?? "Save Changes"}</p>
                </div>
            </div>
            <div
                className={`absolute w-full h-full top-0 left-0 flex items-center justify-center ${showPopup ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                style={{ backgroundColor: "#FCFDFC99", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease", width: "100%" }}
            >
                <div
                    className={`transform transition-transform duration-300 ease-in-out ${showPopup ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                        borderRadius: "6px", backgroundColor: "white", width: "500px", transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    <div
                        className="flex items-center justify-between"
                        style={{
                            padding: "12px 16px",
                            backgroundColor: "#F7F7F8",
                            borderBottom: "1px solid #EBEBED",
                        }}
                    >
                        <p className="text-[16px] font-semibold font-tafel text-main leading-[24px]">
                            Upload photo
                        </p>
                        <div
                            onClick={() => { setShowPopup(false) }}
                            className="flex items-center justify-center cursor-pointer"
                            style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "100%",
                                backgroundColor: "#D1E4E5",
                            }}
                        >
                            <img src={closeIcon} />
                        </div>
                    </div>
                    <div className="space-y-6" style={{ padding: "20px 16px" }}>
                        <span className="text-[14px] font-tafel text-main leading-[24px]">
                            Edit your picture by moving or resizing the circle. You can use your mouse or the arrow, plus and minus keys on your keyboard.
                        </span>
                        <div className="w-[220px] h-[220px] mx-auto bg-[#FCFDFD]">
                            {
                                (image || formValues?.image) ?
                                    <div className="w-full h-full  cursor-pointer rounded-full overflow-hidden" onClick={() => { setShowPopup(true) }}>
                                        <img
                                            src={typeof image === 'string' ? image : (image ? URL.createObjectURL(image) : formValues?.image)}
                                            className="w-full h-full"
                                        />
                                    </div>
                                    :
                                    <div className="w-full h-full border-[3px] border-[#E7F1F1] rounded-full flex items-center justify-center">
                                        <p className="text-[80px] font-tafel text-[#939393] font-semibold"> {formValues?.firstName?.slice(0, 1)}{formValues?.lastName?.slice(0, 1)}</p>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="flex items-center justify-center gap-x-3" style={{ padding: "0px 16px 12px 16px" }}>
                        <div
                            onClick={handleDivClick}
                            className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold border border-[#E2E8F0] h-10 rounded-md"
                        >
                            <img src={uploadIcon} />
                            Upload from computer
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div
                            onClick={() => { handleChooseTakePicture() }}
                            className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold border border-[#E2E8F0] h-10 rounded-md"
                        >
                            <img src={takePicture} />
                            Take a picture
                        </div>
                    </div>
                </div>
            </div>

            <div
                className={`absolute w-full h-full top-0 left-0 flex items-center justify-center ${(showPopupChooseImage) ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                style={{ backgroundColor: "#FCFDFC99", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease", width: "100%" }}
            >
                <div
                    className={`transform transition-transform duration-300 ease-in-out ${(showPopupChooseImage) ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                        borderRadius: "6px", backgroundColor: "white", width: "500px", transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    <div
                        className="flex items-center justify-between"
                        style={{
                            padding: "12px 16px",
                            backgroundColor: "#F7F7F8",
                            borderBottom: "1px solid #EBEBED",
                        }}
                    >
                        <p className="text-[16px] font-semibold font-tafel text-main leading-[24px]">
                            Change Photo
                        </p>
                        <div
                            onClick={() => { setShowPopupChooseImage(false) }}
                            className="flex items-center justify-center cursor-pointer"
                            style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "100%",
                                backgroundColor: "#D1E4E5",
                            }}
                        >
                            <img src={closeIcon} />
                        </div>
                    </div>
                    <div className="space-y-6" style={{ padding: "20px 16px" }}>
                        <span className="text-[14px] font-tafel text-main leading-[24px]">
                            Edit your picture by moving or resizing the circle. You can use your mouse or the arrow, plus and minus keys on your keyboard.
                        </span>
                        <div className="flex flex-col items-center gap-4">
                            {
                                (image && !useCamera) ?
                                    <div className="space-y-5">
                                        <AvatarEditor
                                            ref={editorRef}
                                            image={image as string | File}
                                            width={220}
                                            height={220}
                                            border={0}
                                            borderRadius={110}
                                            color={[0, 0, 0, 0.3]}
                                            scale={scale}
                                            rotate={rotate}
                                        />
                                        <div className="space-y-5">
                                            <div className="flex items-center justify-around h-[34px]">
                                                <div className="flex items-center gap-x-2 cursor-pointer" onClick={() => { setTypeChoose("zoom") }}>
                                                    <img src={typeChoose === "zoom" ? zoomActive : zoom} />
                                                    <p className={`text-[14px] font-tafel leading-[21px] font-medium ${typeChoose === "zoom" ? "text-[#21A6AA]" : "text-[#7A7A7A]"}`}>Zoom</p>
                                                </div>
                                                <div className="flex items-center gap-x-2 cursor-pointer" onClick={() => { setTypeChoose("rotate") }}>
                                                    <img src={typeChoose === "rotate" ? rorateFrameActive : rorateFrame} />
                                                    <p className={`text-[14px] font-tafel leading-[21px] font-medium ${typeChoose === "rotate" ? "text-[#21A6AA]" : "text-[#7A7A7A]"}`}>Rotate</p>
                                                </div>
                                            </div>
                                            {
                                                typeChoose === "zoom"
                                                    ?
                                                    <div className="w-full relative flex items-center justify-center">
                                                        <div className="absolute left-0 top-1/2 -translate-x-1/2"><img src={minus} /></div>
                                                        <input
                                                            type="range"
                                                            min="1"
                                                            max="3"
                                                            step="0.01"
                                                            value={scale}
                                                            className="w-[calc(100%-80px)] "
                                                            onChange={(e) => setScale(parseFloat(e.target.value))}
                                                        />
                                                        <div className="absolute right-0 top-1/2 -translate-y-1/2"><img src={plus} /></div>
                                                    </div>
                                                    :
                                                    <div className="w-full relative flex items-center justify-center">
                                                        <div className="absolute w-5 flex items-center justify-center left-0 "><img src={rorateFrame} /></div>
                                                        <input
                                                            type="range"
                                                            min="0"
                                                            max="360"
                                                            step="1"
                                                            value={rotate}
                                                            className="w-[calc(100%-80px)] "
                                                            onChange={(e) => setRotate(parseFloat(e.target.value))}
                                                        />
                                                        <div className="absolute w-5 flex items-center justify-center right-0 rotate-[360]"><img src={rorateFrame} /></div>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div className="space-y-4">
                                        <Webcam
                                            audio={false}
                                            ref={webcamRef}
                                            screenshotFormat="image/png"
                                            videoConstraints={{
                                                facingMode: 'user'
                                            }}
                                            className="rounded-md"
                                        />
                                        <div className="flex items-center justify-center gap-x-3" >
                                            <div
                                                onClick={() => { setUseCamera(false); setShowPopupChooseImage(false); setShowPopup(true); }}
                                                className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 border border-[#E2E8F0] h-10 rounded-md"
                                            >
                                                Cancel Capture
                                            </div>
                                            <div
                                                onClick={handleCapture}
                                                className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold bg-[#3AC0C4] h-10 rounded-md"
                                            >
                                                <p className="text-[14px] text-main leading-[20px] font-tafel font-semibold ">Capture Photo</p>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="flex items-center justify-center gap-x-3" style={{ padding: "0px 16px 12px 16px" }}>
                        {
                            useCamera ?
                                <></>
                                :
                                <>
                                    <div
                                        onClick={() => { setImage(null); setShowPopupChooseImage(false); setShowPopup(true) }}
                                        className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 border border-[#E2E8F0] h-10 rounded-md"
                                    >
                                        Remove Photo
                                    </div>
                                    <div
                                        onClick={handleSave}
                                        className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold bg-[#3AC0C4] h-10 rounded-md"
                                    >
                                        <p className="text-[14px] text-main leading-[20px] font-tafel font-semibold ">{language?.["Save Changes"] ?? "Save Changes"}</p>
                                    </div>
                                </>
                        }
                    </div>
                </div>
            </div>

            <div
                className={`absolute w-full h-full top-0 left-0 flex items-center justify-center ${showPopupPassword ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"} transition-opacity duration-300 ease-in-out`}
                style={{ backgroundColor: "#FCFDFC99", zIndex: "200", transition: "opacity 0.3s ease, visibility 0.3s ease", width: "100%" }}
            >
                <div
                    className={`transform transition-transform duration-300 ease-in-out ${showPopupPassword ? "translate-y-0" : "translate-y-4 opacity-0"}`} style={{
                        borderRadius: "6px", backgroundColor: "white", width: "500px", transition: "transform 0.3s ease, opacity 0.3s ease",
                    }}
                >
                    <div
                        className="flex items-center justify-between"
                        style={{
                            padding: "12px 16px",
                            backgroundColor: "#F7F7F8",
                            borderBottom: "1px solid #EBEBED",
                        }}
                    >
                        <p className="text-[16px] font-semibold font-tafel text-main leading-[24px]">
                            Change password
                        </p>
                        <div
                            onClick={() => { setShowPopupPassword(false); setFormValuesPassword({ currentPassword: "", newPassword: "", confirmPassword: "" }); setErrors({ ...errors, currentPassword: "", newPassword: "", confirmPassword: "" }) }}
                            className="flex items-center justify-center cursor-pointer"
                            style={{
                                width: "24px",
                                height: "24px",
                                borderRadius: "100%",
                                backgroundColor: "#D1E4E5",
                            }}
                        >
                            <img src={closeIcon} />
                        </div>
                    </div>
                    <div className="space-y-6" style={{ padding: "20px 16px" }}>
                        <div className="space-y-1">
                            <p className="text-[14px] font-tafel text-main leading-[24px] font-semibold">Password strength</p>
                            <span className="text-[14px] font-tafel text-main leading-[24px]">
                                Use at least 9 characters. Don’t use a password from another site, or something too obvious like your pet’s name.
                            </span>
                        </div>
                        <div className="space-y-6">
                            <div className="w-full space-y-2">
                                <p className="text-[14px] text-[#121212] font-tafel no-select">Old Password</p>
                                <div className="relative">
                                    <input
                                        name="currentPassword"
                                        value={formValuesPassword.currentPassword}
                                        onChange={handleChangePassword}
                                        type={showPassword.currentPassword ? "text" : "password"}
                                        className="text-[14px] placeholder:text-[#939393] text-main border border-[#EBEBED] px-4 py-[14px] rounded-md outline-none focus-none bg-transparent w-full"
                                    />
                                    <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                        <img
                                            src={showPassword.currentPassword ? unView : view}
                                            className="w-6 aspect-square cursor-pointer"
                                            onClick={() => { setShowPassword({ ...showPassword, currentPassword: !showPassword.currentPassword }) }}
                                        />
                                    </div>
                                </div>
                                {errors?.currentPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.currentPassword}</p>}
                            </div>
                            <div className="w-full space-y-2">
                                <p className="text-[14px] text-[#121212] font-tafel no-select">New Password</p>
                                <div className="relative">
                                    <input
                                        name="newPassword"
                                        value={formValuesPassword.newPassword}
                                        onChange={handleChangePassword}
                                        type={showPassword.newPassword ? "text" : "password"}
                                        className="text-[14px] placeholder:text-[#939393] text-main border border-[#EBEBED] px-4 py-[14px] rounded-md outline-none focus-none bg-transparent w-full"
                                    />
                                    <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                        <img
                                            src={showPassword.newPassword ? unView : view}
                                            className="w-6 aspect-square cursor-pointer"
                                            onClick={() => { setShowPassword({ ...showPassword, newPassword: !showPassword.newPassword }) }}
                                        />
                                    </div>
                                </div>
                                {errors?.newPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.newPassword}</p>}
                            </div>
                            <div className="w-full space-y-2">
                                <p className="text-[14px] text-[#121212] font-tafel no-select">Confirm New Password</p>
                                <div className="relative">
                                    <input
                                        name="confirmPassword"
                                        value={formValuesPassword.confirmPassword}
                                        onChange={handleChangePassword}
                                        type={showPassword.confirmPassword ? "text" : "password"}
                                        className={`text-[14px] placeholder:text-[#939393] text-main border  px-4 py-[14px]  rounded-md outline-none focus-none bg-transparent w-full ${errors?.confirmPassword.length ? "border-[#E40F03]" : "border-[#EBEBED]"} `}
                                    />
                                    <div className="absolute top-1/2 -translate-y-1/2 right-4">
                                        <img
                                            src={showPassword.confirmPassword ? unView : view}
                                            className="w-6 aspect-square cursor-pointer"
                                            onClick={() => { setShowPassword({ ...showPassword, confirmPassword: !showPassword.confirmPassword }) }}
                                        />
                                    </div>
                                </div>
                                {errors?.confirmPassword.length > 0 && <p className="text-base font-bold text-[#E40F03] ">{errors?.confirmPassword}</p>}
                            </div>
                            <span className="text-[14px] font-tafel text-[#7A7A7A] block">Changing your password will sign you out of all your devices, including your phone. You will need to enter your new password on all your devices.</span>
                        </div>
                    </div>
                    <div className="flex items-center justify-center gap-x-3" style={{ padding: "0px 16px 12px 16px" }}>
                        <div
                            onClick={() => { setShowPopupPassword(false); setFormValuesPassword({ currentPassword: "", newPassword: "", confirmPassword: "" }); setErrors({ ...errors, currentPassword: "", newPassword: "", confirmPassword: "" }) }}
                            className="cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold border border-[#E2E8F0] h-10 rounded-md"
                        >
                            {language?.["Cancel"] ?? "Cancel"}
                        </div>
                        <button
                            disabled={!isFormStepTwo()}
                            onClick={(e: any) => { handleSubmitStepTwo(e) }}
                            className={`cursor-pointer w-1/2 text-[14px] leading-[22px] font-tafel flex items-center justify-center gap-x-4 font-semibold bg-[#3AC0C4] h-10 rounded-md ${isFormStepTwo() ? "bg-[#3ABFC3] text-main" : "bg-[#D8F2F2] text-[#C6C6C6]"}`}
                        >
                            {language?.["Save Changes"] ?? "Save Changes"}
                        </button>
                    </div>
                </div>
            </div >
            {
                showSuccessPopup && (
                    <div className="fixed inset-0  flex items-center justify-center z-[300]">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <h2 className="text-2xl font-bold text-main mb-4">Success!</h2>
                            <p className="text-main mb-6">{messageSuccess}</p>
                            <button onClick={() => { setShowSuccessPopup(false) }}
                                className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-md"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                )
            }
            {
                showFailedPopup && (
                    <div className="fixed inset-0  flex items-center justify-center z-[300]">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4 space-y-6">
                            <h2 className="text-2xl font-bold text-main mb-4">No Camera Detected</h2>
                            <span className="text-main mb-6">We couldn't find a camera device. Please connect a camera or check your browser settings.</span>
                            <button onClick={() => { setShowFailedPopup(false) }}
                                className="w-full bg-[#3ABFC3] text-main font-bold py-3 rounded-md"
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                )
            }
        </div >
    )
}
export default AccountInfor

